export const style = {
  autoCompleteBox: {
    display: 'flex',
    gap: '5px',
    flexDirection: 'column',
    sx: {
      width: '100%',
    },
  },
  card: {
    CardContent: {
      fullWidthField: {
        display: 'flex',
        gap: '10px',
        marginBottom: '10px',
        alignItems: 'center',
      },
      dateBlock: {
        boxMain: {
          display: 'flex',
          gap: 2,
          alignItem: 'center',
        },
        boxInner: {
          width: '100%',
        },
        boxCurrent: {
          display: 'flex',
          alignItems: 'center',
        },
        chackboxLabel: {
          display: 'flex',
          alignItems: 'center',
          height: 61,
        },
        boxRow: {
          display: 'flex',
          marginBottom: '10px',
          alignItems: 'center',
        },
        typography: {
          variant: 'subtitle1',
          width: '100%',
          sx: {
            pb: 1,
            color: 'primary.text',
            fontWeight: '600',
          },
          disabled: {
            color: 'action.active',
          },
          dateBLock: {
            pb: 1,
            color: 'primary.text',
            fontWeight: '600',
          },
        },
        icon: {
          color: 'primary.main',
        },
      },
      cardContentContainer: {
        sx: {
          m: 2,
          pY: 4,
          pX: 2,
          borderRadius: 2,
          border: 1,
          borderColor: 'divider',
        },
      },
      boxRow: {
        display: 'flex',
        gap: '10px',
        marginBottom: '10px',
        alignItems: 'center',
      },
      boxTrash: {
        color: 'action',
        sx: {
          width: 25,
          mt: 2,
          pX: 2,
          '&: hover': {
            cursor: 'pointer',
          },
        },
      },
      textField: {
        field: {
          // color: '#fff',
          width: 180,
          gap: 15,
          flex: 1,
          flexGrow: 1,
        },
        sx: {
          fullWidth: 'fullWidth',
          variant: 'outlined',
        },
      },
      label: {
        style: {
          marginTop: '14px',
          marginBottom: '14px',
          fontWeight: '500',
        },
        sx: {
          color: 'text.primary',
        },
      },
    },
  },
} as const;
